import { collection, onSnapshot } from "firebase/firestore";
import React, { useState, useEffect } from "react";
import { db } from "../Firebase";
import Loading from "./Loading";

const LogoTab = () => {
  const [ldata, setLdata] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const unsubscribe = onSnapshot(collection(db, "logo"), (snapshot) => {
      setLdata(snapshot.docs.map((doc) => ({ id: doc.id, data: doc.data() })));
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  if (loading === true) {
    return <Loading />;
  }

  return (
    <div className="flex justify-center">
      <div className="grid gap-4 lg:grid-cols-4">
        {ldata.map((items) => (
          <div
            key={items.id}
            className="max-w-sm bg-slate-800 rounded-lg overflow-hidden shadow-lg border-2 border-red-500 shadow-red-900"
          >
            <img
              className="w-full h-64 object-fill"
              src={items.data.img}
              alt=""
            />
            <div className="flex flex-col p-3 space-y-4">
              <strong className="">{items.data.name}</strong>
              <small>{items.data.details}</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LogoTab;
